import React from "react";
import { FaArrowRight, FaRegClock, FaUserGroup, FaShieldHalved, FaCheck } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE, H3_SIZE } from "../home/ui";

const points = [
  { icon: FaRegClock, title: "Proactive Monitoring", text: "We detect and fix issues before they affect your users." },
  { icon: FaUserGroup, title: "Expert Team", text: "Experienced developers and support engineers." },
  { icon: FaShieldHalved, title: "Cost-Effective", text: "Flexible plans to fit your needs and budget." },
  { icon: FaCheck, title: "Peace of Mind", text: "Your website is in safe hands." },
];

const MaintWhyChoose = () => (
  <section className="bg-gradient-to-r from-[#0F2C78] via-[#14378F] to-[#0F2C78] py-[48px] lg:py-[60px]">
    <Container className="max-w-[1240px]">
      <div className="grid items-center gap-[36px] lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-[56px]">
        <div>
          <span className="inline-block rounded-full bg-white/15 px-[16px] py-[6px] text-[12px] font-semibold uppercase tracking-[0.04em] text-white">
            Why Choose Us
          </span>
          <h2 className={`mt-[14px] font-extrabold tracking-tight text-white ${H2_SIZE}`}>
            Focus on Your Business,
            {" "}<br />
            We&apos;ll Handle the Rest
          </h2>
          <p className="mt-[14px] max-w-[440px] text-[15px] leading-[1.6] text-white/80 sm:text-[16px]">
            Our proactive maintenance and support services help you avoid downtime, security risks and unexpected issues.
          </p>
          <a
            href="/contact-us"
            className={`group mt-[24px] inline-flex items-center rounded-full bg-white font-medium text-[#1E4DFF] transition hover:bg-[#EEF3FF] ${BTN_SIZE}`}
          >
            Get Started
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>

        <div className="grid gap-x-[40px] gap-y-[32px] sm:grid-cols-2">
          {points.map((p) => (
            <div key={p.title} className="flex items-start gap-[18px]">
              <span className="inline-flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-full bg-white text-[22px] text-[#1E5BFF]">
                <p.icon />
              </span>
              <div>
                <h3 className={`font-bold text-white ${H3_SIZE}`}>{p.title}</h3>
                <p className="mt-[6px] max-w-[240px] text-[14px] leading-[1.55] text-white/75">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default MaintWhyChoose;
